import React from "react";
import { copyright } from "../../data/Data";

function Footer() {
  return (
    <div className="footer fixed-bottom bg-dark text-center">
      <p>
        {copyright}

        <a
          className="backtop"
          href="/"
          data-bs-toggle="tooltip"
          title="Back to top"
        >
          <i className="fas fa-arrow-circle-up"></i>
        </a>
      </p>
    </div>
  );
}
export default Footer;
